import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const WrapperCtx = createContext();

function WrapperContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <WrapperCtx.Provider value={{ state, dispatch }}>
      {children}
    </WrapperCtx.Provider>
  );
}

export default WrapperContext;
